<template>
  <div v-if="applicableTechniques && anesthesiaVideos" class="wrapper">
    <div
      v-for="video in videos"
      class="video-wrapper"
      :class="$mq"
      :key="video.name"
    >
      <div class="video-label">
        {{ translate(video, 'title') }}
      </div>
      <div class="video-description">
        {{ translate(video, 'description') }}
      </div>

      <div class="video">
        <video-player :video="video.name" :key="$i18n.locale" />
      </div>
    </div>
  </div>
</template>

<script>
// This component name is a preexisting condition, disable inspection.
/* eslint vue/multi-word-component-names: 0 */
import { uniq, flattenDeep } from 'lodash';
import videoPlayer from '@/components/VideoPlayer.vue';
import languages from '@/languages';

export default {
  components: { videoPlayer },
  props: [
    'screening',
    'anesthesiaVideos',
    'applicableTechniques',
    'procedure',
    'chosenAnesthesiaOnly',
  ],
  async created() {},
  computed: {
    videos() {
      if (this.chosenAnesthesiaOnly && this.screening.chosen_anesthesia) {
        return this.getChosenVideosOnly();
      }

      if (
        this.procedure &&
        (this.screening.mdl_procedure || this.screening.operation_category)
      ) {
        return this.getProcedureVideos();
      }

      return this.getAllApplicableVideos();
    },
  },
  methods: {
    translate(item, key) {
      return languages.translate(this.$i18n.locale, item, key);
    },
    getChosenVideosOnly() {
      const videoNamesToShow = this.applicableTechniques.find(
        (t) => this.screening.chosen_anesthesia === t.value
      ).videos;

      return videoNamesToShow.map((name) => {
        return this.anesthesiaVideos[name];
      });
    },
    getAllApplicableVideos() {
      const videoNamesToShow = uniq(
        flattenDeep(this.applicableTechniques.map((option) => option.videos))
      );

      return videoNamesToShow.map((name) => {
        return this.anesthesiaVideos[name];
      });
    },
    getProcedureVideos() {
      let result = [];

      switch (this.screening.mdl_procedure) {
        case 'coloscopy':
          result.push(this.anesthesiaVideos.coloscopy);
          break;
        case 'gastroscopy':
          result.push(this.anesthesiaVideos.gastroscopy);
          break;
        case 'ercp':
          result.push(this.anesthesiaVideos.ercp);
          break;
        case 'sigmoidoscopy':
          result.push(this.anesthesiaVideos.sigmoidoscopy);
          break;
        case 'cologastro':
          result.push(this.anesthesiaVideos.coloscopy);
          result.push(this.anesthesiaVideos.gastroscopy);
          break;
      }

      // TODO Andros specific - remove.
      switch (this.screening.operation_category) {
        case 'biopsy':
          result.push(this.anesthesiaVideos.biopsy);
          break;
        case 'vasectomy':
          result.push(this.anesthesiaVideos.vasectomy);
          break;
      }

      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding-bottom: 2rem;
  width: 100%;

  hr {
    width: 100%;
  }
}

.video-wrapper {
  width: 97%;
  padding-bottom: 2rem;
  padding-top: 2rem;

  &.small {
    padding-top: 0;
  }
}

.video-label {
  font-size: 1.1em;
  font-weight: 700;
  text-align: start;
}

.video-description {
  padding-bottom: 1rem;
}

.video {
  margin: auto;
  width: 100%;
  max-width: 800px;
}
</style>
